import * as React from "react"
import envHelper from "@digits-shared/helpers/envHelper"
import { useAtomsDebugValue } from "jotai-devtools"

export const DebugAtoms: React.FC = () => {
  if (envHelper.isProduction()) {
    return null
  }

  return <DebugAtomsHook />
}

const DebugAtomsHook = () => {
  useAtomsDebugValue()
  return null
}
